import { IDS } from '../../../../constants/videos';
import {
    graphicDesign,
    spokesperson,
    liveAction,
    animatedGifs,
    visualEffects,
    socialMediaMarketing,
    seoServices,
    ebookWriting,
    searchEngineMarketing
} from '../../ExplanationVideo/assets/subtitles';
import websiteMatch from '../../BannerVideo/assets/subtitles/websiteMatch';

/**
 * Cannot store video on generic the app root
 * subtitles should be part of client bundle
 * so it will be deployed to S3
 */
const SUBTITLES_BY_NAME = {
    [IDS.GRAPHIC_DESIGN]: graphicDesign,
    [IDS.SPOKESPERSON]: spokesperson,
    [IDS.LIVE_ACTION]: liveAction,
    [IDS.ANIMATED_GIFS]: animatedGifs,
    [IDS.VISUAL_EFFECTS]: visualEffects,
    [IDS.SOCIAL_MEDIA_MARKETING]: socialMediaMarketing,
    [IDS.SEO_SERVICES]: seoServices,
    [IDS.EBOOK_WRITING]: ebookWriting,
    [IDS.SEARCH_ENGINE_MARKETING]: searchEngineMarketing,
    [IDS.WEBSITE_MATCH]: websiteMatch
};

export const getSubtitles = (name) => SUBTITLES_BY_NAME[name];
